import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, OnChanges, Renderer2 } from '@angular/core';
import { HttpService, CoreService, } from '../../../services';
import { TemplateModel } from '../../../models';
import * as echarts from 'echarts';
import { Dictionary } from 'lodash';

@Component({
  templateUrl: './FactMontantGraph.component.html',
  styleUrls: ['./FactMontantGraph.component.css']
})

export class Tpl_FactMontantGraphComponent implements OnInit {

  __TemplateInfo(): any {
    return {
      name: `Graphique Montant d'une Facture`,
      toolTips: `Graphique montrant le total réglé et le reste à régler d'une facture`,
      table: ['tDODocument']
    };
  }

  
  tpl: TemplateModel;
  errorMsg:string;
  _data: Array<any> = new Array<any>();

  @ViewChild('graph', { static: false }) graph: ElementRef;
  myChart: any;

  constructor(
    protected indParam: CoreService,
    protected template: TemplateModel,
    protected http: HttpService,
    protected renderer: Renderer2) {
    this.tpl = template;
  }



  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    //if (this.ChartData && this.ChartData.data.length > 0) {
    //  this.myChart.resize();
    //}
  }
  ngOnInit() {
    this.tpl.Mode = 'FactMontantGraph';
    let result = this.http.postHttp<TemplateModel>(`${this.indParam.AppParams.apiUrl}api/boTemplate/`, this.tpl).subscribe((data: TemplateModel) => {
      if (!data.HasError) { this.buildGraph(data.QueryReturn); }
    });
  }



  buildGraph(pData: Dictionary<any>): void {
    //if (this.ChartData.data.length > 0) {
    const style: CSSStyleDeclaration = getComputedStyle(document.body);
    const Cmain: string = style.getPropertyValue('--c-main');
    const Csecondary: string = style.getPropertyValue('--c-secondary');
    const clightmain: string = style.getPropertyValue('--c-light-main');


    if (pData["montantReg"].toFixed(2) != 0.00) {
      this._data.push({ value: pData["montantReg"].toFixed(2), name: 'réglé', itemStyle: { color: Cmain }, label: { position: 'inside' } })
    }
    if (pData["montantRest"].toFixed(2) != 0.00) {
      this._data.push({ value: pData["montantRest"].toFixed(2), name: 'à régler', itemStyle: { color: Csecondary }, label: { position: 'inside' } })
    }

    if (this._data.length == 0) {
      this.errorMsg = "Pas de données à afficher";    
    }
    if (pData["montantReg"] < 0 || pData["montantRest"].toFixed(2) < 0) {
      this.errorMsg = "Montant négatif";    
    }

    if (!this.errorMsg) {


      //  const zoomMaxValue: number = this.ChartData.data.length > 21 ? Math.ceil(2000 / this.ChartData.data.length) : 100;

      setTimeout(() => {
        this.myChart = echarts.init(this.graph.nativeElement);
        this.myChart.setOption({
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
          },
          label: { formatter: function (data: any) { return data.value; } },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: this._data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        });


        this.renderer.setStyle(this.graph.nativeElement, 'width', `100%`);
        this.renderer.setStyle(this.graph.nativeElement, 'height', `100%`);
        this.myChart.resize();
      }, 1);

  

    
    }
    //const interval = setInterval(() => {
    //  const width = $(this.IdChart.includes("#") ? `${this.IdChart}` : `#${this.IdChart}`).width();
    //  const height = $(this.IdChart.includes("#") ? `${this.IdChart}` : `#${this.IdChart}`).height();
    //  if (width > 0 && height > 0) {
    //    this.renderer.setStyle(this.graph.nativeElement, 'width', `${width}px`);
    //    this.renderer.setStyle(this.graph.nativeElement, 'height', `${height}px`);
    //    this.myChart.resize();
    //    clearInterval(interval);
    //  }
    //}, 100);
  }  

}



